module.exports = __webpack_public_path__ + "img/thumbnail_Reindeer_f_albino.cc45cdb8.png";